import React, { useState } from "react";
import { cancelRestaurantReservation } from "../../../action/resReservation";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";


const CancelReservationPopUp = (props) => {

    const { t } = props

    const [loading , setLoading] = useState(false);
    const [reason, setReason] = useState("");

    let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})

    const handleDeleteReservation = async () => {
        setLoading(true); 
        let deletedSuccessfully = true; 
      
        for (const id of props.cancelReservationId) {

          const payload = {
            id: id,
            cancellationComments: reason,
          };
      
          try {
            const res = await cancelRestaurantReservation(payload);
      
            if (res.status !== 200 || res.data.Status !== 200) {
              deletedSuccessfully = false;

                props.sendAnalytics(
                    props.guestDetail, 
                    props.currentWidgets.widgetType, 
                    "DELETE RESERVATION - ERROR", 
                    {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("resReservationSessionToken"), "deleteReservationID": id  ,"errorStatus": res.data.Status, "errorMessage": JSON.stringify(res.data)}, 
                    0, 
                    props.guestIsLoggedIn
                );
            } else {
                props.sendAnalytics(
                    props.guestDetail, 
                    props.currentWidgets.widgetType,
                    "DELETE RESERVATION - Success", 
                    {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("resReservationSessionToken"), "deleteReservationID": id}, 
                    0, 
                    props.guestIsLoggedIn
                );
            }
          } catch (err) {
            console.log(err);
            deletedSuccessfully = false;
          }
        }
      
        setLoading(false);
        props.handleDeleteReservation(deletedSuccessfully);
      };


    React.useEffect(() => {
        console.log(props.cancelReservationId)
    }, [])

    return (
        <>
            <section class="overlay">
                <div class="overlay-window-container">
                    <div class="overlay-window">
                        <div class="overlay-content padding-0">
                            <div class="overlay-header">
                                <div class="overlay-header-title">
                                    <h2 style={{ color: "#000 !important" }}>{t('resReservation.cancel_reser.heading1')}</h2>
                                    <p>{t('resReservation.cancel_reser.subHeading')}</p>
                                </div>
                                <div class="overlay-header-icon">
                                    <i class="fas fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                        <div class="overlay-controls form-row margin-top-0 align-left">
                            <label>{t('resReservation.cancel_reser.reason_heading')}</label>
                            <input type="text" name="Cancellation Reason" value={reason} onChange={(e) => setReason(e.target.value)} placeholder={t('resReservation.cancel_reser.reason_placeholder')} />
                        </div>
                        <div class="overlay-controls">
                            { loading ? <button disabled class="button"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('resReservation.cancelling')}</button> : <button onClick={() => handleDeleteReservation()} class="button">{t('resReservation.cancel')}</button>}
                            <button onClick={() => props.close()} class="button secondary">{t('resReservation.close')}</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}


const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(CancelReservationPopUp));